import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getVideoCategories = async () => {
  const { data, error } = await supabase
    .from('video_categories')
    .select('*')

  if (error) {
    throw error
  }

  return data
}

export default function useGetVideoCategories() {
  return useQuery({
    queryKey: ['videoCategories'],
    queryFn: getVideoCategories
  })
} 